import { Component, OnInit, AfterViewInit } from '@angular/core';
import {Router} from '@angular/router';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {StsPortalStatus} from '../../../models/sts-portal-status';
import {StsPortalStatusService} from '../../../services/sts-portal-status.service';

@Component({
  selector: 'app-account-thank-you',
  templateUrl: './account-thank-you.component.html',
  styleUrls: ['./account-thank-you.component.scss']
})
export class AccountThankYouComponent implements OnInit, AfterViewInit {

  public isMemberPortal = true;
  public isLoggedIn = false;
  public isLockedInThankYou = true;
  errors;

  constructor(private tenantService: StsTenantService,
              private portalStatusService: StsPortalStatusService,
              private router: Router) { }

  ngOnInit() {
  }

  ngAfterViewInit() {

   this.portalStatusService.getPortalStatus().subscribe((portalStatus: StsPortalStatus) => {

      this.isLoggedIn = portalStatus.isLoggedIn;
      this.isMemberPortal = portalStatus.isMemberPortal;

      this.tenantService.getTenantSource().subscribe(tenant => {

        this.isLockedInThankYou = tenant.isLockedInThankYou;
        if (!this.isLockedInThankYou) {
          console.log('Thank you not required, redirecting to home');
          window.location.href = '/Account/Signout';
          return;
        }

      });
    });
  }

}
